import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CoreService } from 'src/app/services/core.service';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MatListItem, MatNavList } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Module } from 'src/assets/types/interfaces';
import { Router } from '@angular/router';

@Component({
  selector: 'app-iconmenu',
  standalone: true,
  templateUrl: './iconmenu.component.html',
  imports: [
    TablerIconsModule,
    MatListItem,
    MatNavList,
    MatButtonModule,
    MatTooltipModule,
  ],
})
export class IconMenuComponent implements OnChanges {
  options = this.settings.getOptions();

  @Input() menuItems: Module[] = [];

  findId: any;
  selectedMenu: any;
  @Output() toggleCollapsed = new EventEmitter<void>();
  @Output() openClosedMenu = new EventEmitter<void>();
  @Output() iconSelected = new EventEmitter<number>();
  constructor(
    private settings: CoreService,
    private router: Router,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['menuItems'] && this.menuItems.length > 0) {
      this.updateSelectedMenu();
    }
  }

  getFlattenedItems(items: Module[] = []): Module[] {
    const result: Module[] = [];
    for (let item of items) {
      result.push(item);
    }
    return result;
  }

  selectIcon(icon: number) {
    this.iconSelected.emit(icon);
    this.selectedMenu = icon;
  }

  private updateSelectedMenu(): void {
    const currentPath = `/${this.router.url.split('/')[1]}`;
    const activeMenuItem = this.menuItems.find(
      (item) => item.route === currentPath,
    );
    const firstModulePosition = Math.min(
      ...this.menuItems.map((item) => item.menu_position),
    );

    this.selectedMenu = activeMenuItem?.menu_position ?? firstModulePosition;
    this.iconSelected.emit(this.selectedMenu);
  }

  findParentRouteId(routes: any, url: any): any {
    for (const route of routes) {
      if (route.route === url) {
        return route.id;
      }
      if (route.children && Array.isArray(route.children)) {
        for (const child of route.children) {
          if (child.route === url) {
            return route.id;
          }
        }
      }
    }
    return null;
  }
}
